import Body from 'components/DashboardLayout/Body';
import Header from 'components/DashboardLayout/Header';
import React from 'react';

const DashboardPage = ({
  WelcomeHeader,
  MenuItem,
  NotificationsBloc,
  MyContracts,
  LastSinistre,
  ServicesBloc,
  Faq,
  HeaderImage,
}: {
  MyContracts: React.ReactNode;
  LastSinistre?: React.ReactNode;
  ServicesBloc?: React.ReactNode;
  Faq: React.ReactNode;
  WelcomeHeader: React.ReactNode;
  MenuItem: React.ReactNode;
  NotificationsBloc: React.ReactNode;
  HeaderImage: string;
}) => {
  return (
    <>
      <Header
        WelcomeHeader={WelcomeHeader}
        MenuItem={MenuItem}
        HeaderImage={HeaderImage}
        NotificationsBloc={NotificationsBloc}
      />
      <Body
        MyContracts={MyContracts}
        lastSinistre={LastSinistre}
        ServicesBloc={ServicesBloc}
        Faq={Faq}
      />
    </>
  );
};

export default DashboardPage;
